/**
 * <custom-bs-scroller> — scroller de cards del Banner + Slider dual género.
 *
 * Desktop (>=1150px), según data-axis:
 *  - 'y' (banner izquierda): pagina el grid verticalmente por filas (translateY).
 *  - 'x' (banner arriba): pagina el slider horizontalmente por card (translateX).
 * Transición en CSS; flechas se deshabilitan en los extremos.
 * Móvil/tablet: scroll horizontal nativo con snap — sin JS.
 * El cambio de género lo pinta CSS puro (fade desde html[data-custom-gender]);
 * cada grupo conserva su propia posición al alternar.
 */
const DESKTOP_MQ = window.matchMedia('(min-width: 1150px)');

class CustomBsScroller extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    const { signal } = this.abortController;

    this.track = this.querySelector('.custom_bs__track');
    this.prevBtn = this.querySelector('.custom_bs__nav-btn--prev');
    this.nextBtn = this.querySelector('.custom_bs__nav-btn--next');
    this.axis = this.dataset.axis === 'x' ? 'x' : 'y';
    this.cols = parseInt(this.dataset.cols, 10) || 2;
    this.visibleRows = parseInt(this.dataset.rows, 10) || 2;
    this.index = 0;
    if (!this.track) return;

    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(-1), { signal });
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(1), { signal });
    DESKTOP_MQ.addEventListener('change', () => this.update(), { signal });
    window.addEventListener('resize', () => this.update(), { signal });

    document.addEventListener(
      'shopify:block:select',
      (event) => {
        const root = this.closest('.custom_bs');
        if (!root || !root.contains(event.target)) return;
        const group = event.target.closest('.custom_bs__group');
        if (!group || !window.customGender) return;
        const gender = group.classList.contains('custom_bs__group--man') ? 'man' : 'woman';
        window.customGender.set(gender, 'editor');
      },
      { signal }
    );

    this.update();
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  maxIndex() {
    const count = this.track.children.length;
    if (this.axis === 'x') return Math.max(0, count - this.cols);
    const totalRows = Math.ceil(count / this.cols);
    return Math.max(0, totalRows - this.visibleRows);
  }

  go(direction) {
    this.index = Math.min(Math.max(this.index + direction, 0), this.maxIndex());
    this.update();
  }

  update() {
    if (!DESKTOP_MQ.matches) {
      this.index = 0;
      this.track.style.transform = '';
      return;
    }
    this.index = Math.min(this.index, this.maxIndex());
    const childIndex = this.axis === 'x' ? this.index : this.index * this.cols;
    const target = this.track.children[childIndex];
    if (this.axis === 'x') {
      const offset = target ? target.offsetLeft : 0;
      this.track.style.transform = offset ? `translateX(-${offset}px)` : '';
    } else {
      const offset = target ? target.offsetTop : 0;
      this.track.style.transform = offset ? `translateY(-${offset}px)` : '';
    }
    if (this.prevBtn) this.prevBtn.disabled = this.index === 0;
    if (this.nextBtn) this.nextBtn.disabled = this.index >= this.maxIndex();
  }
}

if (!customElements.get('custom-bs-scroller')) {
  customElements.define('custom-bs-scroller', CustomBsScroller);
}
